import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import AnimatedSection from '../ui/AnimatedSection';

const GlobalPresence = () => {
  return (
    <section id="global-presence" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Global Presence</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Strategically located to serve users worldwide.
            </p>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-w-5xl mx-auto">
          <AnimatedSection delay={0.1}>
            <div className="dark-card rounded-xl transition-all duration-300 p-8 text-center relative z-10">
              <div className="mb-4 text-blue-400 flex justify-center">
                <FaMapMarkerAlt className="text-4xl" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-white">Headquarters</h3>
              <p className="text-gray-300">
                Hazaribag, Jharkhand<br />
                India
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="dark-card rounded-xl transition-all duration-300 p-8 text-center relative z-10">
              <div className="mb-4 text-blue-400 flex justify-center">
                <FaMapMarkerAlt className="text-4xl" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-white">Service Areas</h3>
              <p className="text-gray-300">
                Pan-India Services<br />
                Global Reach
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.3}>
            <div className="dark-card rounded-xl transition-all duration-300 p-8 text-center relative z-10">
              <div className="mb-4 text-blue-400 flex justify-center">
                <FaMapMarkerAlt className="text-4xl" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-white">Remote Services</h3>
              <p className="text-gray-300">
                Worldwide Coverage<br />
                Online Support
              </p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default GlobalPresence;

